import api
from "../client";

export const getMedia =
  params =>
    api.get(
      "/media",
      { params }
    );

export const getStorage =
  () =>
    api.get(
      "/media/storage"
    );

export const uploadMedia =
  payload =>
    api.post(
      "/media/upload",
      payload
    );

export const getMediaUrl =
  id =>
    api.get(
      `/media/${id}/url`
    );
export const loadMediaById =
  id =>
    api.get(
      `/media/${id}`
    );


export const deleteMedia =
  id =>
    api.delete(
      `/media/${id}`
    );

export const restoreMedia =
  id =>
    api.patch(
      `/media/${id}/restore`
    );


    export const bulkDeleteMedia =
    payload =>
        api.delete(

            "/media/bulk-delete",

            {

                data: payload

            }

        );